import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../../environments/environment';

@Injectable()
export class CargaDescuentosService 
{
 
    constructor(private http: HttpClient) { }
    /*
    creaCargaMasiva(cargaMasiva: any,idUsuario:any)
    {
        let file:FormData = new FormData()    
        file.append('file', cargaMasiva.archivo, cargaMasiva.archivo.name) 
        cargaMasiva.tipoCarga="PRESTAMOINICIAL";      
        console.log("PRESTAMOINICIAL:"+cargaMasiva.tipoCarga)
        return this.http.post(`${environment.urlApiCargas}/cargaInicial/tipo/${cargaMasiva.tipoCarga}/usuario/${idUsuario}`, file,
        { headers: this.armaCabecera2() } ).toPromise()
    }
 */
  /*
    creaCargaMasiva(cargaMasiva: any,idUsuario:any)
    {
        let file:FormData = new FormData()    
        file.append('file', cargaMasiva.archivo, cargaMasiva.archivo.name) 
        cargaMasiva.tipoCarga="DESCUENTOUSUARIO";      
        console.log("DESCUENTOUSUARIO:"+cargaMasiva.tipoCarga)
        return this.http.post(`${environment.urlApiCargas}/cargaInicial/tipo/${cargaMasiva.tipoCarga}/usuario/${idUsuario}`, file,
        { headers: this.armaCabecera2() } ).toPromise()
    }
   */
    /*
    creaCargaMasivaCONVENIOINICIAL(cargaMasiva: any,idUsuario:any)
    {
        let file:FormData = new FormData()    
        file.append('file', cargaMasiva.archivo, cargaMasiva.archivo.name) 
        cargaMasiva.tipoCarga="CONVENIOINICIAL";      
        console.log("CONVENIOINICIAL:"+cargaMasiva.tipoCarga)
        return this.http.post(`${environment.urlApiCargas}/cargaInicial/tipo/${cargaMasiva.tipoCarga}/usuario/${idUsuario}`, file,
        { headers: this.armaCabecera2() } ).toPromise()
    }*/
    
	creaCargaMasiva(cargaMasiva: any,idUsuario:any)
    {
        let file:FormData = new FormData()    
        file.append('file', cargaMasiva.archivo, cargaMasiva.archivo.name) 
        cargaMasiva.tipoCarga="DESCUENTOUSUARIO";      
        return this.http.post(`${environment.urlApiCargas}/cargas/tipo/${cargaMasiva.tipoCarga}/usuario/${idUsuario}`, file,
        { headers: this.armaCabecera2() } ).toPromise()
    }
  
	

    armaCabecera2()
    {
        return new HttpHeaders({
            'Authorization': 'Bearer ' + localStorage.getItem("jwt"),
            'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE',
            'Access-Control-Allow-Origin': '*',
        })
    }
}